<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="500">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="success" dark v-on="on" @click="check_user">Deposer</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Depot USDT <img src="/img/usdt.svg" width="40"
            style="margin: 3px" alt="cfa" /> </v-card-title>
        <div v-if="show_iframe">
          <p class="subheading red--text" style="text-align:center">vous navez pas besoin de faire un depot avant de
            vendre,
            vous pouvez initier la vente directement sur la page d'échange, de cette façon vous recevez votre
            transaction
            juste apres l'envoi, dans peu de temps les depots ne seront plus disponibles, cliquez sur le lien dessous pour
            voir
            comment faire la vente directement et ainsi gagner en temps </p>
          <div class="iframe-container mt-5" style="width:400px;">
            <iframe width="533" height="300" src="https://www.youtube.com/embed/0w9Nw9Ktkj4" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>

        
        <v-card-text>
          <div v-if="adre">
            <v-flex text-xs-center xs12>
              <!-- <v-flex xs12>
                <div class="center">
                  <v-select :items="networks" v-model="network" label="Choisir le reseau" @change="generate"></v-select>
                </div>
              </v-flex> -->
              <!-- <div v-if="qr" style="text-align:center;">
                <v-flex text-xs-center xs12>
                  <p class="caption red--text"> Envoyez uniquement USDT {{ network }} à cette adresse</p>
                  <div @click="copy(btcAdr)" style="cursor:pointer;">
                    <qrcode-vue class="" :value="btcAdr" size="170" level="H"></qrcode-vue>
                  </div>
                  <br />
                  <p @click="copy(btcAdr)" style="cursor:pointer;">{{ btcAdr }}</p>
                  <p class="caption green--text" v-if="copied" style="line-height:30%;">Adresse USDT {{ network }} copié
                    avec
                    success!</p>
                  <p class="caption" v-if="!copied" @click="copy(btcAdr)" style="cursor:pointer;line-height:50%;">
                    cliquer sur
                    l'adresse ou le QR pour copier</p>
                  <p class="caption" v-if="!copied">une fois votre transaction confirmé votre compte sera
                    automatiquement
                    credité</p>
                </v-flex>
              </div> -->

              <!-- <v-layout column wrap>
                <v-flex xs6>
                  <v-btn color="success" v-if="btcAdr.length > 5" @click="copy(btcAdr)">copier</v-btn>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-center">
                    <v-btn color="success" v-if="btcAdr.length > 5" @click="show_iframe = true">Retour</v-btn>
                  </div>


                </v-flex>
              </v-layout> -->
              <!-- <strong class="red--text"> option en maintenance pour ameliorer le service, revenez après un instant </strong> -->
            </v-flex>
          </div>
        </v-card-text>


        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { mapGetters, mapActions } from "vuex";
import firebase from "../../../fb";
import db from "../../../db";
import axios from 'axios'

const copy = require('clipboard-copy')


export default {
  components: {
    QrcodeVue,

  },
  data() {
    return {
      dialog: false,
      copied: false,
      size: 170,
      msg: "waiting...",
      etat: "attente",
      gen: true,
      network: '',
      qr: false,
      attente: false,
      warning: true,
      hh: false,
      btcAdr: '',
      recu: false,
      adre: true,
      show_iframe: true,
      networks: ["BSC(BEP20)"], //"TRC20", 

    };
  },
  computed: {
    ...mapGetters({
      index: "deposit/index"
    })
  },
  mounted() {
    this.bind_addresses()
  },
  methods: {
    copy(address) {
      copy(address)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 4000);
    },
    async generate() {
      this.btcAdr = ''
      this.qr = false
      this.show_iframe =false
      console.log(this.network);

      let asset = 'usdt'
      let network
      switch (this.network) {
        case 'TRC20': network = 'trc20'
          break;
        case 'BSC(BEP20)': network = 'bep20'
          break;
        default:
          break;
      }
      let base_url = this.base_url
      if (location.hostname === "localhost") {
        base_url = 'http://localhost:4000'
      }
      let url = base_url + '/coinpayment/generate_hiropay_deposit_address'
      console.log(url);
      let my_addresses = this.$store.getters["deposit/address"]

      console.log(my_addresses);
      console.log(this.$store.state["deposit"]);


      if (my_addresses == undefined || my_addresses[`${asset}_${network}`] == undefined) {
        console.log('no addesse');
        const loading = this.$vs.loading()
        let auth_token = await this.firebase_auth_token()
        let user = firebase.auth().currentUser;
        let currency = `${asset}.${network}`
        currency = currency.toUpperCase()
        console.log(currency);
        axios.post(url, {
          currency: currency,
          asset,
          network,
          user_id: user.uid
        }, auth_token).then(res => {
          let { address } = res.data
          console.log(address);
          loading.close()
          this.btcAdr = address
          this.qr = true;
        })

      } else {

        this.btcAdr = my_addresses[`${asset}_${network}`]
        console.log(my_addresses[`${asset}_${network}`]);
        this.qr = true
      }
    },

    check_user() {
      let user = this.$store.getters['authfb/user']
      if (!user) {
        swal("Erreur survenu!", "contactez le support et fournissez votre email pour assistance avant d'effecturer le dépot!", "error", {
          button: "ok"
        })
        setTimeout(() => {
          this.dialog = false
        }, 1000);

      }
    },

    ...mapActions("deposit", ["bind_addresses"]),
  }
};
</script>

<style scoped>
.projet.attente {
  color: black;
}

.projet.attente {
  border-left: none;
}

.projet.recu {
  color: green;
}
</style>
